import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {ShopRoutingModule} from './shop-routing.module';
import {SharedModule} from '../shared/shared.module';
import {SlickCarouselModule} from 'ngx-slick-carousel';
import {InfiniteScrollModule} from 'ngx-infinite-scroll';
import {HomeFourComponent} from './home-4/home-four.component';
import {SliderComponent} from './home-4/slider/slider.component';
import {SpecialProductsComponent} from './home-4/special-products/special-products.component';
import {ProductComponent} from './product/product.component';
import {ProductLeftSidebarComponent} from './product/product-details/product-left-sidebar/product-left-sidebar.component';
import {CartComponent} from './product/cart/cart.component';
import {CheckoutComponent} from './product/checkout/checkout.component';
import {SuccessComponent} from './product/success/success.component';
import {MaterialModule} from '../shared/material.module';
import {ProductCardComponent} from './product/product-card/product-card.component';
import {MercadoPagoComponent} from './product/mercado-pago/mercado-pago.component';
import { SearchComponent } from './home-4/search/search.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        ShopRoutingModule,
        SharedModule,
        MaterialModule,
        SlickCarouselModule,
        InfiniteScrollModule
    ],
    declarations: [
        HomeFourComponent,
        SpecialProductsComponent,
        SliderComponent,
        ProductComponent,
        ProductLeftSidebarComponent,
        CartComponent,
        CheckoutComponent,
        SuccessComponent,
        ProductCardComponent,
        MercadoPagoComponent,
        SearchComponent
    ]
})
export class ShopModule {
}
